<template>
    <div class="c-wave">
        <span class="axis axis-l"></span>
        <span class="f f-1"></span>
        <span class="f f-2"></span>
        <span class="f f-3"></span>
        <span class="f f-4"></span>
        <span class="f f-5"></span>
        <span class="f f-6"></span>
        <span class="f f-7"></span>
        <span class="axis axis-r"></span>
    </div>
</template>


<script>

export default {

    name: 'VWave'

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-wave {
    position: relative;
    font-size: 1px;
    width: 40em;
    height: 27em;

    @include bp($screen-sm) {
        font-size: 0.5px;
    }
    span {
        position: absolute;
        background-color: $c-primary;
        border-radius: 1em;
        top: 50%;
        transform: translateY(-50%);

        &.axis {
            width: 4em;
            height: 2em;

            &-l {
                left: 0;
            }
            &-r {
                right: 0;
            }
        }
        &.f {
            width: 2em;
            height: 2em;
            animation: wave .7s ease-in-out infinite;

            &.f-1 {
                height: 7em;
            }
            &.f-2 {
                height: 20em;
            }
            &.f-3 {
                height: 13em;
            }
            &.f-4 {
                height: 27em;
            }
            &.f-5 {
                height: 20em;
            }
            &.f-6 {
                height: 27em;
            }
            &.f-7 {
                height: 13em;
            }
            @for $i from 1 through 7 {
                &.f-#{$i} {
                    animation-delay: 0.5s - calc(random(300) / 300);
                    left: 3em + ($i * 4em);
                }
            }
        }
        @keyframes wave {
            50% {
                height: 2em;
            }
        }
    }
}

</style>
